import { useState } from 'react';
import type { Quadrant as QuadrantKey, Task } from '../types';
import { QUADRANTS, QUADRANT_LABELS } from '../types';
import { Quadrant } from './Quadrant';

interface Props {
  tasks: Task[];
  readOnly: boolean;
  onAdd: (quadrant: QuadrantKey, title: string) => Promise<void>;
  onUpdate: (id: string, patch: Partial<Pick<Task, 'title' | 'notes' | 'quadrant'>>) => Promise<void>;
  onDelete: (id: string) => Promise<void>;
  onMove: (id: string, to: QuadrantKey) => Promise<void>;
}

export function Matrix({ tasks, readOnly, onAdd, onUpdate, onDelete, onMove }: Props) {
  const [activeTab, setActiveTab] = useState<QuadrantKey>('do');

  const tasksByQuadrant: Record<QuadrantKey, Task[]> = {
    do: [], schedule: [], delegate: [], eliminate: [],
  };
  for (const t of tasks) tasksByQuadrant[t.quadrant].push(t);

  return (
    <>
      {/* Mobile tabs */}
      <nav className="mobile-tabs">
        {QUADRANTS.map((q) => (
          <button
            key={q}
            type="button"
            className={q === activeTab ? 'active' : ''}
            onClick={() => setActiveTab(q)}
          >
            {QUADRANT_LABELS[q].title}
            <span className="mobile-tab-count">{tasksByQuadrant[q].length}</span>
          </button>
        ))}
      </nav>

      {/* Desktop grid: all four visible */}
      <div className="matrix-grid">
        {QUADRANTS.map((q) => (
          <div
            key={q}
            className={`matrix-cell ${q === activeTab ? 'matrix-cell--active' : ''}`}
          >
            <Quadrant
              quadrant={q}
              tasks={tasksByQuadrant[q]}
              readOnly={readOnly}
              onAdd={onAdd}
              onUpdate={onUpdate}
              onDelete={onDelete}
              onMove={onMove}
            />
          </div>
        ))}
      </div>
    </>
  );
}
